import type { MarlinStoreDb } from "../infra/db";
import type { OffsetRecord } from "../types";

export const getSubscriptionOffset = async (
  db: MarlinStoreDb,
  machineId: number,
  topic: string,
): Promise<number> => (await db.offsets.get([machineId, topic]))?.offset ?? 0;

export const setSubscriptionOffset = async (
  db: MarlinStoreDb,
  machineId: number,
  topic: string,
  offset: number,
): Promise<void> => {
  await db.offsets.put({ machineId, topic, offset });
};

export const getAllSubscriptionOffsets = async (
  db: MarlinStoreDb,
): Promise<Record<number, Record<string, number>>> => {
  const grouped: Record<number, Record<string, number>> = {};
  for (const row of (await db.offsets.toArray()) as OffsetRecord[])
    (grouped[row.machineId] ??= {})[row.topic] = row.offset;
  return grouped;
};
